export default __webpack_public_path__ + "static/media/background.07af07e6.svg";